import angular from 'angular';

import CategoryChartComponent from './category-chart.cmpt';

export default angular
    .module('application.scene.authorized.scene.dashboard.component.category-chart', [])
    .component(CategoryChartComponent.selector, CategoryChartComponent);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/dashboard/component/category-chart/index.js